import { Routes, Route } from "react-router-dom";
import AppRoutes from "../AppRoutes";
import IndividualTaskManagement from "./IndividualTaskManagement";
import YourForms from "./YourForms";
import YourJourneyCatchUps from "./YourJourneyCatchUps";

function YourJourneyRoot() {
  // The `key` prop is there so that the component is re-mounted when the URL changes
  return (
    <>
      <Routes>
        <Route
          path={AppRoutes.yourJourney.sub.conversations.path}
          element={<YourForms formType="CONVERSATIONS" key="CONVERSATIONS" />}
        />
        <Route
          path={AppRoutes.yourJourney.sub.pulseChecks.path}
          element={<YourForms formType="PULSE-CHECKS" key="PULSE-CHECKS" />}
        />
        <Route
          path={AppRoutes.yourJourney.sub.catchUps.path}
          element={<YourJourneyCatchUps />}
        />
        <Route
          path={AppRoutes.yourJourney.sub.tasks.path}
          element={<IndividualTaskManagement />}
        />
        <Route
          path={AppRoutes.yourJourney.sub.tasks.pathWithTaskId}
          element={<IndividualTaskManagement />}
        />
      </Routes>
    </>
  );
}

export default YourJourneyRoot;
